import type { LostReport, Animal } from '../types/models'

/** Demo cases so the CSI UI feels alive before the API is wired. */
export const demoLost: Array<LostReport & { animal: Animal }> = [
  {
    id: 1,
    animal_id: 101,
    contact_info: 'WhatsApp +297 000 0000',
    user_id: 'demo',
    status: 'active',
    created_at: '2026-07-16T14:00:00Z',
    updated_at: '2026-07-16T14:00:00Z',
    animal: {
      id: 101,
      type: 'dog',
      breed_id: 1,
      color1: 'brown_chocolate',
      color2: 'white',
      color3: null,
      chip: null,
      spayed: null,
      ownership_status: 'reported_lost',
      if_found_contact: 'Call Maria',
      moderator_notes: null,
      created_at: '2026-07-16T14:00:00Z',
      updated_at: '2026-07-16T14:00:00Z',
    },
  },
  {
    id: 2,
    animal_id: 102,
    contact_info: 'sms +297 111 1111',
    user_id: 'demo',
    status: 'active',
    created_at: '2026-07-17T09:30:00Z',
    updated_at: '2026-07-17T09:30:00Z',
    animal: {
      id: 102,
      type: 'cat',
      breed_id: 26,
      color1: 'gray_blue',
      color2: 'white',
      color3: null,
      chip: '982000123456789',
      spayed: 1,
      ownership_status: 'reported_lost',
      if_found_contact: 'Text owner ASAP',
      moderator_notes: null,
      created_at: '2026-07-17T09:30:00Z',
      updated_at: '2026-07-17T09:30:00Z',
    },
  },
]

export const demoSightings = [
  {
    id: 499,
    animal_id: 101,
    type: 'dog' as const,
    lat: 12.546,
    lng: -70.002,
    sighted_at: '2026-07-10T18:20:00Z',
    color1: 'brown_chocolate' as const,
  },
  {
    id: 1910,
    animal_id: 101,
    type: 'dog' as const,
    lat: 12.538,
    lng: -69.995,
    sighted_at: '2026-07-15T11:05:00Z',
    color1: 'brown_chocolate' as const,
  },
  {
    id: 2104,
    animal_id: 102,
    type: 'cat' as const,
    lat: 12.515,
    lng: -69.974,
    sighted_at: '2026-07-17T20:40:00Z',
    color1: 'gray_blue' as const,
  },
]
